import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-226d5384"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manifold nft-promo-note m-discount-eligible" }
const _hoisted_2 = { class: "icon-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "promo-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.customStarImage)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.customStarImage
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _ctx.starCheckmark
          }, null, 8, _hoisted_4))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", null, _toDisplayString(_ctx.discountEligibleTitle), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.discountEligibleMessage), 1)
    ])
  ]))
}